// extracted by mini-css-extract-plugin
export default {"main":"styles_main__6sSxc","img":"styles_img__wSC-F","data":"styles_data__zPofA"};